import React, { useState } from 'react';
import { getBackendOrigin } from '../../utils/backendUrl';

const BACKEND_URL = getBackendOrigin();

function formatLabelImageSrc(src) {
  if (!src || typeof src !== 'string') return null;
  const trimmed = src.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  return `${BACKEND_URL}${trimmed.startsWith('/') ? '' : '/'}${trimmed}`;
}

function LabelAvatarItem({ label, isFirst }) {
  const [imgError, setImgError] = useState(false);
  const rawSrc = label.imageUrl || label.image_url || label.image;
  const src = formatLabelImageSrc(rawSrc);
  const initial = label.name ? label.name.trim().charAt(0).toUpperCase() : 'L';

  const avatarStyle = {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid #ffffff',
    marginLeft: isFirst ? 0 : '-8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
  };

  if (src && !imgError) {
    return (
      <img
        src={src}
        alt={label.name}
        title={label.name}
        className="avatar-stacked"
        style={avatarStyle}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div
      className="avatar-stacked label-initial-avatar"
      title={label.name}
      style={{
        ...avatarStyle,
        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: '700',
        textTransform: 'uppercase',
        userSelect: 'none'
      }}
    >
      {initial}
    </div>
  );
}

function LabelAvatarStack({ labels, maxVisible = 3 }) {
  let list = [];
  if (Array.isArray(labels)) {
    list = labels.map((item, idx) => {
      if (typeof item === 'string') {
        return { id: idx, name: item, imageUrl: null };
      }
      return {
        id: item.id || idx,
        name: item.name || item.labelName || 'Record Label',
        imageUrl: item.imageUrl || item.image_url || null
      };
    });
  } else if (typeof labels === 'string' && labels && labels !== 'None' && labels !== '—') {
    list = labels.split(', ').map((name, idx) => ({ id: idx, name, imageUrl: null }));
  }

  if (list.length === 0) {
    return <span style={{ color: '#94a3b8', fontSize: '13px' }}>None</span>;
  }

  const visible = list.slice(0, maxVisible);
  const extraCount = list.length - maxVisible;

  return (
    <div className="avatar-stack" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      {visible.map((label, idx) => (
        <LabelAvatarItem key={label.id || idx} label={label} isFirst={idx === 0} />
      ))}
      {extraCount > 0 && (
        <div 
          className="avatar-stacked more-badge" 
          title={list.slice(maxVisible).map(l => l.name).join(', ')}
          style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: '#e2e8f0',
            color: '#334155',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '11px',
            fontWeight: '700',
            border: '2px solid #ffffff',
            marginLeft: '-8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
          }}
        >
          +{extraCount}
        </div>
      )}
    </div>
  );
}

export default LabelAvatarStack;
